var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-default',[_c('vue-headful',{attrs:{"title":"Até o Futuro - Nossos Experts"}}),_c('div',{staticClass:"box"},[_c('h1',{staticClass:"title is-3"},[_vm._v("Até o Futuro - Conheça nossos Experts")]),_c('contributors')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }